import HTTP from '.';
import TokenServiceMock from './mocks/TokenService.mock';
import config from '@/config';

export default class TokenService {
  static token(username, password) {
    if (config.ENV.MOCK === true) {
      return TokenServiceMock.token();
    }

    return HTTP.post('/api/Token/', {
      username,
      password,
    });
  }

  static refreshToken(username, refreshToken) {
    if (config.ENV.MOCK === true) {
      return TokenServiceMock.refreshToken();
    }

    return HTTP.post(
      '/api/Token/refresh',
      { username, refreshToken },
      { handleHttpError: false },
    );
  }
}
